<template>
  <div>
	<div class="header">
			<a href="http://www.verder.cn/cn/zh/" target="_blank"><div class="icon"><img src="../assets/img/header/LOGO.png" ></div></a>
			<div class="nav">
				<ul>
				 <!-- <li v-for="(item,index) in navList" :class="menuIndex==index?'select':''"
				    @click="menuIndex=index">
				    <a :href="item.herf" >{{item.name}}</a>
				  </li> -->
          <li @click="menuIndex=0"><a href="http://www.verder.cn/cn/zh/" target="_blank">首页</a></li>
          <li @click="menuIndex=1"><a href="http://www.verder.cn/cn/zh/hygienic-pumps/"target="_blank" >卫生泵</a></li>
          <li @click="menuIndex=2"><a href="http://www.verder.cn/cn/zh/industrial-pumps/" target="_blank">工业泵</a></li>
          <li @click="menuIndex=3"><a href="#3" >咨询报价</a></li>
          <li @click="menuIndex=4"><a href="http://www.verder.cn/cn/zh/company/" target="_blank">关于我们</a></li>
				</ul>
			</div>
			<div class="number">
        <!-- <div class="iconfont iconWeb-kefudianhua" style="color: #00539C; margin-right: 8px;line-height: 22px; font-size: 20px; float: left;"></div> -->
        <!-- <div style="width: 255px;">021-33932950 或 18301997215</div> -->
      </div>
	</div>
	</div>
</template>
<script >
  import '@/assets/sass/header.css'
  export default {
    name: 'headers',
    data() {
      return {
		  menuIndex: 0,
		  navList: [{
		      name: '首页',
		      herf: 'http://www.verder.cn/cn/zh/'
		    },
		    {
		      name: '卫生泵',
		      herf: 'http://www.verder.cn/cn/zh/hygienic-pumps/'
		    },
		    {
		      name: '工业泵',
		      herf: 'http://www.verder.cn/cn/zh/industrial-pumps/'
		    },
		    {
		      name: '咨询报价',
		      herf: '#3'
		    },
		    {
		      name: '关于我们',
		      herf: 'http://www.verder.cn/cn/zh/company/'
		    }
		  ],

      }
    },
    watch:{
    },
    methods: {
     // getPathIndex() {
     //     if (this.$route.path == "/") {
     //       return 0
     //     } else if (this.$route.path == "/introduction") {
     //       return 1
     //     } else if (this.$route.path == "/caseCenter") {
     //       return 2
     //     }
     // 		else if (this.$route.path == "/cooperativePartner") {
     //       return 3
     //     }
     //  else if (this.$route.path == "/about") {
     //       return 3
     //     }
     //   },
    }
  }
</script>
<style>
.select {
  color: #00539C;
}
a {
  -webkit-user-select: none;

  -moz-user-focus: none;

  -moz-user-select: none;
  color: #333333;
}
a,a:hover,a:active,a:visited,a:link,a:focus{

-webkit-tap-highlight-color:rgba(0,0,0,0);

-webkit-tap-highlight-color: transparent;

outline:none;
color: #333333;
background: none;

text-decoration: none;

}
</style>



// WEBPACK FOOTER //
// src/components/headers.vue